export default __webpack_public_path__ + "static/media/IBMPlexSans-LightItalic-Latin1.e885531f.woff2";